import * as constants from './constants';
import { createReducer } from '../../utils';
import initialState from './initialstate';

export default createReducer(initialState, {
  [constants.LOGOUT_USER_SUCCESS]: (state, payload) => ({
    ...state, viewer: initialState.viewer, statusText: 'You have been successfully logged out.',
  }),
  [constants.LOGIN_USER_SUCCESS]: (state, payload) => ({
    ...state, viewer: payload, statusText: 'You have been successfully logged in.',
  }),
  [constants.LOGIN_USER_NEW_PASSWORD_REQUIRED]: (state, payload) => ({
    ...state, viewer: { ...initialState.viewer, ...payload }, statusText: 'New Password Required.',
  }),
  [constants.LOGIN_USER_FAILURE]: (state, payload) => ({
    ...state, viewer: { ...state.viewer, ...payload }, statusText: 'Login Failure.',
  }),
  [constants.LOGIN_CLEAR_ERRORS]: (state, payload) => ({
    ...state, viewer: payload,
  }),
});
